/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Eyebrow_AccountInputs */

const en_us2_profile_editors_eyebrow_account = /** @type {(inputs: Profile_Editors_Eyebrow_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const pt_br2_profile_editors_eyebrow_account = /** @type {(inputs: Profile_Editors_Eyebrow_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta`)
};

const es_419_profile_editors_eyebrow_account = /** @type {(inputs: Profile_Editors_Eyebrow_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta`)
};

const pt_pt2_profile_editors_eyebrow_account = /** @type {(inputs: Profile_Editors_Eyebrow_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta`)
};

const fr_fr2_profile_editors_eyebrow_account = /** @type {(inputs: Profile_Editors_Eyebrow_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte`)
};

const de_de2_profile_editors_eyebrow_account = /** @type {(inputs: Profile_Editors_Eyebrow_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

const it_it2_profile_editors_eyebrow_account = /** @type {(inputs: Profile_Editors_Eyebrow_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {Profile_Editors_Eyebrow_AccountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_eyebrow_account = /** @type {((inputs?: Profile_Editors_Eyebrow_AccountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Eyebrow_AccountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_eyebrow_account(inputs)
	if (locale === "es-419") return es_419_profile_editors_eyebrow_account(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_eyebrow_account(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_eyebrow_account(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_eyebrow_account(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_eyebrow_account(inputs)
	return en_us2_profile_editors_eyebrow_account(inputs)
});
export { profile_editors_eyebrow_account as "profile-editors.eyebrow_account" }